export const useAuthStore = defineStore('auth', {
  state: () => ({
    bearerToken: '',
    refreshToken: ''
  }),
  actions: {
    setTokens({ bearerToken, refreshToken }: { bearerToken: string; refreshToken: string }) {
      this.bearerToken = bearerToken
      this.refreshToken = refreshToken
    },
    clearTokens() {
      this.bearerToken = ''
      this.refreshToken = ''
    }
  },
  persist: {
    storage: piniaPluginPersistedstate.cookies({
      expires: useCookieExpire.weeks(1)
    })
  }
})
